<template>
  <div class="relative w-full">
    <div>
      <input
        type="range"
        step="100"
        :min="min"
        :max="max"
        v-model.number="selectedMin"
        @input="onMinInput"
        class="absolute pointer-events-none appearance-none z-20 h-2 w-full opacity-0 cursor-pointer"
      />

      <input
        type="range"
        step="100"
        :min="min"
        :max="max"
        v-model.number="selectedMax"
        @input="onMaxInput"
        class="absolute pointer-events-none appearance-none z-20 h-2 w-full opacity-0 cursor-pointer"
      />

      <div class="relative z-10 h-2">
        <div class="absolute z-10 left-0 right-0 bottom-0 top-0 rounded-md bg-neutral-light"></div>
        <div
          class="absolute z-20 top-0 bottom-0 rounded-md bg-primary"
          :style="`right:${maxPosition}%; left:${minPosition}%`"
        ></div>
        <div
          class="absolute z-30 w-6 h-6 top-0 left-0 bg-primary rounded-full -mt-2 -ml-1"
          :style="`left: ${minPosition}%`"
        ></div>
        <div
          class="absolute z-30 w-6 h-6 top-0 right-0 bg-primary rounded-full -mt-2 -mr-3"
          :style="`right: ${maxPosition}%`"
        ></div>
      </div>
    </div>

    <div class="flex justify-between items-center gap-2 py-3 sm:py-5">
      <div class="flex-1">
        <input
          type="text"
          maxlength="5"
          v-model="selectedMin"
          @input="onMinInput"
          class="px-2 py-2 border border-neutral-light rounded w-full sm:w-24 text-center text-sm"
        />
      </div>
      <div class="flex-1">
        <input
          type="text"
          maxlength="5"
          v-model="selectedMax"
          @input="onMaxInput"
          class="px-2 py-2 border border-neutral-light rounded w-full sm:w-24 text-center text-sm"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  min: { type: Number, default: 0 },
  max: { type: Number, default: 1000 },
  initialMin: { type: Number, default: null },
  initialMax: { type: Number, default: null },
});

const emit = defineEmits(['min-changed', 'max-changed']);

const userHasSetMin = ref(props.initialMin != null);
const userHasSetMax = ref(props.initialMax != null);

const selectedMin = ref(props.initialMin ?? props.min);
const selectedMax = ref(props.initialMax ?? props.max);

watch(() => props.min, (val) => { if (!userHasSetMin.value) selectedMin.value = val; });
watch(() => props.max, (val) => { if (!userHasSetMax.value) selectedMax.value = val; });

const minPosition = computed(() => {
  const range = props.max - props.min;
  return range > 0 ? ((selectedMin.value - props.min) / range) * 100 : 0;
});

const maxPosition = computed(() => {
  const range = props.max - props.min;
  return range > 0 ? 100 - ((selectedMax.value - props.min) / range) * 100 : 0;
});

function onMinInput() {
  userHasSetMin.value = true;
  emit('min-changed', Number(selectedMin.value));
}

function onMaxInput() {
  userHasSetMax.value = true;
  emit('max-changed', Number(selectedMax.value));
}
</script>
